import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Service} from '../../../../core/entities/service/service.entity';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppImageComponent} from '../../../../core/components/image/image';

@Component({
  selector: 'app-service-item',
  imports: [
    TranslocoPipe,
    AppImageComponent,
  ],
  templateUrl: './service-item.component.html',
  standalone: true,
  styleUrl: './service-item.component.scss'
})
export class ServiceItemComponent {
  @Input() service!: Service;
  @Output() onEdit = new EventEmitter<Service>();
  @Output() deleted = new EventEmitter<Service>();

  public editService() {
    this.onEdit.emit(this.service);
  }

  public getFormattedServiceDescription(service: Service): string {
    const bio = service.description ?? '';
    return bio.replace(/\n/g, '<br>');
  }
}
